/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerBedUnit } from './ScreenerBedUnit';
import {
    ScreenerBedUnitFromJSON,
    ScreenerBedUnitFromJSONTyped,
    ScreenerBedUnitToJSON,
} from './ScreenerBedUnit';

/**
 * 
 * @export
 * @interface BulkUpdateScreenerBedUnitsRequest
 */
export interface BulkUpdateScreenerBedUnitsRequest {
    /**
     * 
     * @type {Array<ScreenerBedUnit>}
     * @memberof BulkUpdateScreenerBedUnitsRequest
     */
    units: Array<ScreenerBedUnit>;
}

/**
 * Check if a given object implements the BulkUpdateScreenerBedUnitsRequest interface.
 */
export function instanceOfBulkUpdateScreenerBedUnitsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "units" in value;

    return isInstance;
}

export function BulkUpdateScreenerBedUnitsRequestFromJSON(json: any): BulkUpdateScreenerBedUnitsRequest {
    return BulkUpdateScreenerBedUnitsRequestFromJSONTyped(json, false);
}

export function BulkUpdateScreenerBedUnitsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateScreenerBedUnitsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'units': ((json['units'] as Array<any>).map(ScreenerBedUnitFromJSON)),
    };
}

export function BulkUpdateScreenerBedUnitsRequestToJSON(value?: BulkUpdateScreenerBedUnitsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'units': ((value.units as Array<any>).map(ScreenerBedUnitToJSON)),
    };
}

